var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Page",
    { attrs: { titleType: "custom" } },
    [
      _c(
        "template",
        { slot: "header-left-dropdown" },
        [
          _c("PageHeaderTabs", {
            staticClass: "m-left-10",
            attrs: {
              links: _vm.pageTabLinks,
              translationGroup: "PortalPlusEDespatch",
            },
          }),
        ],
        1
      ),
      _c("template", { slot: "overgroups-left" }, [
        _c(
          "div",
          { staticClass: "control form-item-select" },
          [
            _c("Icon", { attrs: { name: "icon-down-arrow" } }),
            _c("customSelectInput", {
              attrs: { hideDefault: "", optionData: _vm.storeGroups },
              on: { change: _vm.getIntegrationStoreGroupWithParams },
              model: {
                value: _vm.selectedStoreGroup,
                callback: function ($$v) {
                  _vm.selectedStoreGroup = $$v
                },
                expression: "selectedStoreGroup",
              },
            }),
          ],
          1
        ),
      ]),
      _c(
        "template",
        { slot: "content-center" },
        [
          _vm.isFetchingSettingInfo || _vm.isFetchingData
            ? _c("TableLoading")
            : _c("StoreGroupConfigForm", {
                attrs: {
                  form: _vm.form,
                  isPortalPlus: true,
                  isLoadingAction: _vm.isLoading,
                },
                on: { onSubmitAction: _vm.onSubmitForm },
              }),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }